/*
 * @Author: leoqyli leoqyli@tencent.com
 * @Date: 2022-02-10 14:33:02
 * @LastEditors: leoqyli leoqyli@tencent.com
 * @LastEditTime: 2022-07-18 10:19:31
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/js/utils/getDatasourceByGroupId/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* eslint-disable */
import colleague from './colleague';
import QQFriend from './QQfriend';
import troopMember from './troopMember';
import cloudPhoneBook from './cloudPhoneBook';
import companyWeChatOrg from './companyWeChatOrg';
import GQQFriend from './GQQFriend';
import customeBase from './customeBase';

export default {
    troop: null,
    Gtroop: null,
    QQFriend,
    colleague,
    troopMember,
    cloudPhoneBook,
    companyWeChatOrg,
    GQQFriend,
    customeBase
};
